import { useCallback } from 'react';

const useFilterData = () => {

    const findAdvertiserName = useCallback((arr, id) => {
        const advertiser = arr.find( item => item.id === id)
        return advertiser ? advertiser.name : null
    }, []);

    const findWebsiteBaseUrl = useCallback((listOfWebsite, websiteId) => {
        const website = listOfWebsite.find( ws => ws.entityId === websiteId)
        return website ? website.baseUrl : null
    }, []);

    const findGraphqlData = useCallback((arr, val, searchKey, returnKey) => {
        const data = arr.find( item => item[searchKey] === val);
        if (returnKey === '') {
            return data;
        }

        return data ? data[returnKey] : null
    }, []);

    const findOfferById = useCallback((allOffer, offerId) => {
        return allOffer.find(offer => offer.offerId === offerId)
    }, [])

    const filterGraphqlData = useCallback((arr, val, searchKey) => {
        const data = arr.filter( item => item[searchKey] === val);
    
        return data || [];
    }, []);

    return {
        findAdvertiserName,
        findGraphqlData,
        filterGraphqlData,
        findWebsiteBaseUrl,
        findOfferById
    };
}

export default useFilterData;